import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, vModelText as _vModelText, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "content-header" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row mb-2" }
const _hoisted_4 = { class: "col-sm-6" }
const _hoisted_5 = { class: "col-sm-6" }
const _hoisted_6 = { class: "breadcrumb float-sm-right" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("li", { class: "breadcrumb-item" }, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, "Home")
], -1)
const _hoisted_8 = { class: "breadcrumb-item active" }
const _hoisted_9 = { class: "content" }
const _hoisted_10 = { class: "container-fluid" }
const _hoisted_11 = { class: "card" }
const _hoisted_12 = { class: "card-header" }
const _hoisted_13 = { class: "card-title" }
const _hoisted_14 = { class: "card-tools" }
const _hoisted_15 = ["title"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-left" }, null, -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = { class: "card-body row" }
const _hoisted_19 = { class: "form-group col-12 col-md-6" }
const _hoisted_20 = { for: "id_category" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "*", -1)
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "form-group col-12 col-md-6" }
const _hoisted_24 = { for: "id_category" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("sup", { class: "text-danger" }, "*", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "form-group col-12 col-md-6" }
const _hoisted_28 = { for: "price" }
const _hoisted_29 = { class: "form-group col-12 col-md-6" }
const _hoisted_30 = { for: "discount" }
const _hoisted_31 = { class: "form-group col-12 col-md-6" }
const _hoisted_32 = { for: "description" }
const _hoisted_33 = { class: "form-group col-12 col-md-6" }
const _hoisted_34 = { for: "image" }
const _hoisted_35 = { class: "form-group col-12 col-md-6" }
const _hoisted_36 = { for: "is_highlight" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_38 = { class: "form-group col-12 col-md-6" }
const _hoisted_39 = { for: "image_highlight" }
const _hoisted_40 = { class: "form-group col-12 col-md-6" }
const _hoisted_41 = { for: "platform_video_name" }
const _hoisted_42 = { class: "form-group col-12 col-md-6" }
const _hoisted_43 = { for: "video_display_name" }
const _hoisted_44 = { class: "form-group col-12 col-md-6" }
const _hoisted_45 = { for: "enabled" }
const _hoisted_46 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_47 = { class: "form-group col-12 col-md-6" }
const _hoisted_48 = { for: "isFree" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_50 = { class: "card-footer text-center" }
const _hoisted_51 = { class: "btn-group" }

export function render(_ctx, _cache) {
  const _component_Toggle = _resolveComponent("Toggle")
  const _directive_money = _resolveDirective("money")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", null, _toDisplayString(_ctx.$t("labels.page.product")), 1)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("ol", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("li", _hoisted_8, _toDisplayString(_ctx.$t("labels.page.product")), 1)
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_9, [
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("h3", _hoisted_13, _toDisplayString(_ctx.$t("labels.buttons.new")), 1),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-tool",
                onClick: _cache[0] || (_cache[0] = $event => (_ctx.goBack())),
                title: _ctx.$t('labels.buttons.goBack')
              }, _hoisted_17, 8, _hoisted_15)
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _withDirectives(_createElementVNode("div", { class: "col-12 alert alert-danger" }, _toDisplayString(_ctx.errorMessage), 513), [
              [_vShow, _ctx.errorMessage != '']
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("label", _hoisted_20, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.category")) + " ", 1),
                _hoisted_21
              ]),
              _withDirectives(_createElementVNode("select", {
                id: "id_category",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.row.id_category) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.id_category }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categorys, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_22))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.id_category]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.id_category), 513), [
                [_vShow, _ctx.errors.id_category != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, [
                _createTextVNode(_toDisplayString(_ctx.$t("labels.entity.type")) + " ", 1),
                _hoisted_25
              ]),
              _withDirectives(_createElementVNode("select", {
                id: "type",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.row.type) = $event)),
                style: {"width":"auto","max-width":"-webkit-fill-available"},
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.type }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.types, (i, k) => {
                  return (_openBlock(), _createElementBlock("option", {
                    value: i.id,
                    key: k
                  }, _toDisplayString(i.description), 9, _hoisted_26))
                }), 128))
              ], 2), [
                [_vModelSelect, _ctx.row.type]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.type), 513), [
                [_vShow, _ctx.errors.type != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("label", _hoisted_28, _toDisplayString(_ctx.$t("labels.entity.price")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "price",
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => ((_ctx.row.price) = $event)),
                placeholder: "0.00",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.price }])
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.row.price,
                  void 0,
                  { lazy: true }
                ],
                [_directive_money, _ctx.money]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.price), 513), [
                [_vShow, _ctx.errors.price != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t("labels.entity.discount")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "discount",
                type: "text",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => ((_ctx.row.discount) = $event)),
                placeholder: "0.00",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.discount }])
              }, null, 2), [
                [
                  _vModelText,
                  _ctx.row.discount,
                  void 0,
                  { lazy: true }
                ],
                [_directive_money, _ctx.money]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.discount), 513), [
                [_vShow, _ctx.errors.discount != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_31, [
              _createElementVNode("label", _hoisted_32, _toDisplayString(_ctx.$t("labels.entity.description")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "description",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => ((_ctx.row.description) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.description }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.description]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.description), 513), [
                [_vShow, _ctx.errors.description != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_33, [
              _createElementVNode("label", _hoisted_34, _toDisplayString(_ctx.$t("labels.entity.image")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "image",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => ((_ctx.row.image) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.image }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.image]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.image), 513), [
                [_vShow, _ctx.errors.image != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_35, [
              _createElementVNode("label", _hoisted_36, _toDisplayString(_ctx.$t("labels.entity.is_highlight")), 1),
              _hoisted_37,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.is_highlight,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => ((_ctx.row.is_highlight) = $event)),
                "on-label": _ctx.$t('labels.yes'),
                "off-label": _ctx.$t('labels.no')
              }, null, 8, ["modelValue", "on-label", "off-label"])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _createElementVNode("label", _hoisted_39, _toDisplayString(_ctx.$t("labels.entity.image_highlight")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "image_highlight",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => ((_ctx.row.image_highlight) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.image_highlight }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.image_highlight]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.image_highlight), 513), [
                [_vShow, _ctx.errors.image_highlight != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("label", _hoisted_41, _toDisplayString(_ctx.$t("labels.entity.platform_video_name")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "platform_video_name",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => ((_ctx.row.platform_video_name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.platform_video_name }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.platform_video_name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.platform_video_name), 513), [
                [_vShow, _ctx.errors.platform_video_name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t("labels.entity.video_display_name")), 1),
              _withDirectives(_createElementVNode("input", {
                id: "video_display_name",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => ((_ctx.row.video_display_name) = $event)),
                type: "text",
                class: _normalizeClass(["form-control", { 'is-invalid': _ctx.errors.video_display_name }]),
                maxlength: "200"
              }, null, 2), [
                [_vModelText, _ctx.row.video_display_name]
              ]),
              _withDirectives(_createElementVNode("span", { class: "help-inline" }, _toDisplayString(_ctx.errors.video_display_name), 513), [
                [_vShow, _ctx.errors.video_display_name != null]
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("label", _hoisted_45, _toDisplayString(_ctx.$t("labels.entity.active")), 1),
              _hoisted_46,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.enabled,
                "onUpdate:modelValue": _cache[11] || (_cache[11] = $event => ((_ctx.row.enabled) = $event)),
                "on-label": _ctx.$t('labels.yes'),
                "off-label": _ctx.$t('labels.no')
              }, null, 8, ["modelValue", "on-label", "off-label"])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("label", _hoisted_48, _toDisplayString(_ctx.$t("labels.entity.isFree")), 1),
              _hoisted_49,
              _createVNode(_component_Toggle, {
                modelValue: _ctx.row.isFree,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => ((_ctx.row.isFree) = $event)),
                "on-label": _ctx.$t('labels.yes'),
                "off-label": _ctx.$t('labels.no')
              }, null, 8, ["modelValue", "on-label", "off-label"])
            ])
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              _createElementVNode("button", {
                type: "button",
                id: "cancelButton",
                class: "btn btn-sm btn-warning",
                onClick: _cache[13] || (_cache[13] = $event => (_ctx.goBack()))
              }, _toDisplayString(_ctx.$t("labels.buttons.cancel")), 1),
              _createElementVNode("button", {
                type: "button",
                id: "gravarButton",
                class: "btn btn-sm btn-success",
                onClick: _cache[14] || (_cache[14] = $event => (_ctx.save()))
              }, _toDisplayString(_ctx.$t("labels.buttons.save")), 1)
            ])
          ])
        ])
      ])
    ])
  ], 64))
}